// src/views/auth/signIn/SignInPage.jsx
import React from "react";
import SignIn from "./index";

export default function SignInPage() {
  return <SignIn />;
}
